import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.5 20a2.5 2.5 0 1 1-5 0H4a2 2 0 1 1 0-4v-5a8.003 8.003 0 0 1 6.161-7.788 2 2 0 0 1 3.678 0A8.003 8.003 0 0 1 20 11v5a2 2 0 1 1 0 4h-5.5zm5.5-3a1 1 0 0 1-1-1v-5a7.003 7.003 0 0 0-5.39-6.814 1 1 0 0 1-.69-.58 1 1 0 0 0-1.84 0 1 1 0 0 1-.69.58A7.003 7.003 0 0 0 5 11v5a1 1 0 0 1-1 1 1 1 0 0 0 0 2h16a1 1 0 0 0 0-2zm-9.5 3a1.5 1.5 0 0 0 3 0h-3z"
});

var SvgBell = function SvgBell(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgBell;